__turbopack_context__.v({
  "modal": "Dialog-module-scss-module__B84RCW__modal",
  "narrow": "Dialog-module-scss-module__B84RCW__narrow",
  "overlay": "Dialog-module-scss-module__B84RCW__overlay",
  "wide": "Dialog-module-scss-module__B84RCW__wide",
});
